import api from "../../../api/axios";

const BASE_URL = "/api/v1/power/dossiers";

const getDossiers = async (params = {}) => {
  const response = await api.get(BASE_URL, {
    params,
  });

  return response.data;
};

const getDossierById = async (id) => {
  const response = await api.get(`${BASE_URL}/${id}`);

  return response.data;
};

const createDossier = async (payload) => {
  const response = await api.post(BASE_URL, payload);

  return response.data;
};

const updateDossier = async ({ id, data }) => {
  const response = await api.patch(`${BASE_URL}/${id}`, data);

  return response.data;
};

const updateDossierValues = async ({ id, values }) => {
  const response = await api.patch(`${BASE_URL}/${id}/values`, {
    values,
  });

  return response.data;
};

const archiveDossier = async (id) => {
  const response = await api.patch(`${BASE_URL}/${id}/archive`);

  return response.data;
};

const restoreDossier = async (id) => {
  const response = await api.patch(`${BASE_URL}/${id}/restore`);

  return response.data;
};

const dossierService = {
  getDossiers,
  getDossierById,
  createDossier,
  updateDossier,
  updateDossierValues,
  archiveDossier,
  restoreDossier,
};

export default dossierService;
